import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as amplify from "../util/amplify.ts";
import * as forms from "../util/forms.js";

import ApiServer from "../ApiServer.js";
import * as DateUtils from "../lib/DateUtils.ts";
import TPL_MODALCOPY from "./modal_copyweek.mustache";
import TPL_MODALPLAN from "./modal_recipeplan.mustache";
import TPL_PICKTYPE from "./modal_pickmealtype.mustache";
 import Icons from "../svg/Icons.ts";
import { apiCustommplist, dishSyncCache, getWeekRange, MealplannerSettingsCache, mealSyncCache, updateMealplannerSettings } from "./mealplannerApi.ts";
import { TEMPLATE } from "../TEMPLATE.ts";

export {openCopyWeek,openRecipePlan}

export async function modalmealplannersettings(){
  return new Promise(async (resolve,reject)=>{
    const 
      settings = await MealplannerSettingsCache.need(),
      TPL = await import("../mealplanner/modal_settings.mustache"),
      theModal = modal.openModal(TPL,settings);
    var 
      changed = false;
    theModal.find('form').one('submit', async function(){
      var settings = await MealplannerSettingsCache.need()
      var form = this;
      $(form.display).each((i,checkbox)=>{
        settings.columns.find(c=>c.type===$(checkbox).data('type')).display = checkbox.checked;
      });
      $(form.emoji).each((i,input)=>{
        settings.columns.find(c=>c.type===$(input).data('type')).emoji = input.value;
      });
      $(form.name).each((i,input)=>{
        if(input.value==='') return;
        settings.columns.find(c=>c.type===$(input).data('type')).name = input.value;
      });
      $(form.timeSlot).each((i,input)=>{
        if(input.value.length){
          settings.columns.find(c=>c.type===$(input).data('type')).timeSlot = input.value;
        }
      });
      await updateMealplannerSettings(settings)
      changed = true;
      modal.closeModal(theModal);
    })
    theModal.onClose = ()=>{console.log(changed);resolve(changed)}
  })  
}


function openCopyWeek(targetDate :Date,weekSourceDate :Date){
  var 
    range = getWeekRange(weekSourceDate),
    theModal :modal.Modal;
  function update(){
    apiCustommplist(range).then(function(mplistResponse){
      modal.closeModal(theModal)
      theModal = modal.openModal(TPL_MODALCOPY,{
        range:range,
        days:mplistResponse.days
      });
      theModal.find('[data-fw-onclick="mpprevweek"]').on('click',()=>{
        range=getWeekRange(range.prev);
        update()
      }).removeAttr('data-fw-onclick').css('cursor','pointer');
      
      theModal.find('[data-fw-onclick="mpnextweek"]').on('click',()=>{
        range=getWeekRange(range.next);
        update()
      }).removeAttr('data-fw-onclick').css('cursor','pointer');
      
      theModal.find('[data-fw-onclick="submit"]').on('click',async ()=>{
        
        function doit(){
          ApiServer.mpcopy(DateUtils.forInputDate(range.start),DateUtils.forInputDate(range.end),DateUtils.forInputDate(targetDate),function(createdDishes){
            modal.closeModal(theModal);
            amplify.publish('dishChange');
            modal.toast({svg:Icons.ic_done,text:"mp.copysuccess",button:[{title:'actions.undo',onclick:function(){
              ApiServer.metadelete(createdDishes.map(dish=>dish.metaId))
              dishSyncCache.invalidate();
              amplify.publish('dishChange');
            }}]});
          })
          dishSyncCache.invalidate();
        }
        if(mplistResponse.list.length===0){
          modal.closeModal();
          modal.toast({text:"mp.copyempty"});
        }else if(DateUtils.forInputDate(range.start)==DateUtils.forInputDate(targetDate)){
          if(await modal.confirm("mp.copyconfirmself")){
            doit()
          }
        }else{
          doit()
        }
      }).removeAttr('data-fw-onclick').css('cursor','pointer');
      
    })
    
  }
  update()
  
}


function openRecipePlan(recipeId :string){
  var 
    range = getWeekRange(new Date()),
    theModal :modal.Modal;
  function update(){
    apiCustommplist(range).then(function(mplistResponse){
      modal.closeModal(theModal)
      theModal = modal.openModal(TPL_MODALPLAN,{
        range:range,
        days:mplistResponse.days
      });
      theModal.find('[data-fw-onclick="mpprevweek"]').on('click',()=>{
        range=getWeekRange(range.prev);
        update()
      }).removeAttr('data-fw-onclick').css('cursor','pointer');
      
      theModal.find('[data-fw-onclick="mpnextweek"]').on('click',()=>{
        range=getWeekRange(range.next);
        update()
      }).removeAttr('data-fw-onclick').css('cursor','pointer');
      
      theModal.find('[data-day]').on('click',async function(){
        var 
          day = $(this).attr('data-day'),
          mealtype = await openPickMealType(),
          mealplannerSettings = await MealplannerSettingsCache.need();

        if(mealtype){
          ApiServer.mprecipeput(new ApiServer.types.RecipeInputBean({metaId:recipeId,isMealSuggestion:true}))
          ApiServer.mpcreateByRecipeId(recipeId,day,mealtype,function(){
            modal.closeModal(theModal);

            
            var 
              mealTypeName = mealplannerSettings.columns.find(col=>col.type===mealtype).displayName,
              dayName = DateUtils.toLocaleString(new Date(day),{month: 'long', day: 'numeric' }),
              text = i18n.get('mp.recipeplanned',{mealTypeName,dayName})

            modal.toast({svg:Icons.ic_done,text});
          })
          dishSyncCache.invalidate()
        }
        
        
        
      }).css('cursor','pointer');
      
    })
    
  }
  update()
  
}

function openPickMealType(){
  return new Promise((resolve,reject)=>{
    ApiServer.mpsettingsget(settings=>{
      var theModal = modal.openModal(TPL_PICKTYPE,settings);
      theModal.find("[data-type]").on("click",function(){
        resolve($(this).attr("data-type"))
        theModal.onClose = undefined;
        modal.closeModal(theModal)
      })
      theModal.onClose = ()=>{resolve(null)}
      
    })  
  })
}

export async function modalMeal(date :Date|undefined, type:string|undefined){
  var 
    meal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type),
    theModal = modal.openModal(await import('./modal_mealcreate.mustache'),{
      settings:await MealplannerSettingsCache.need(),
      meal
    }),
    form = theModal.find('form'),
    dateInput = form.find('[name=date]'),
    servesInput = form.find('[name=serves]'),
    noteInput = form.find('[name=note]'),
    typeInput = form.find('[name=type]');
  
  var options = {0:i18n.get('labels.none')};  
  for(var i=1;i<100;i++){
    options[i] = i.toString()
  }
  servesInput.html(Object.entries(options).map(([key,val])=>TEMPLATE`<option value="${key}">${val}</option>`).join(''))  
  servesInput.val(servesInput.attr('value')||'0')
  typeInput.val(typeInput.attr('value')||'LUNCH')
    
  function loadMeal(){
    var 
      date = dateInput.val(),
      type = typeInput.val(),
      theMeal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type)
    
    if(theMeal){
      servesInput.val(theMeal.serves),
      noteInput.val(theMeal.note)
    }else{
      servesInput.val('0'),
      noteInput.val('')
    }  
  }  

  dateInput.on('change',loadMeal)
  typeInput.on('change',loadMeal)

  form.on('submit',function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!forms.validate(form)){
      return false;
    }
    var 
      dish = form.find('[name=dish]').val(),
      date = dateInput.val(),
      type = typeInput.val(),
      serves = servesInput.val(),
      note = noteInput.val();
      
    if(serves||note){
      ApiServer.mpmealput({date,type,serves,note});
      mealSyncCache.invalidate()
    }
    if(dish){
      ApiServer.mpcreate([dish],date,type);
      dishSyncCache.invalidate()
    }
    modal.closeModal(theModal)
    amplify.publish('dishChange')
  })
  return theModal
}

export async function modalMealEditSimple(date :Date, type:string){
  var 
    meal = mealSyncCache.datas.find(meal=>meal.date===date && meal.type===type),
    theModal = modal.openModal(await import('./modal_mealedit.mustache'),{
      meal
    }),
    form = theModal.find('form'),
    servesInput = form.find('[name=serves]'),
  
  noteInput = form.find('[name=note]');
  
  var options = {0:i18n.get('labels.none')};  
  for(var i=1;i<100;i++){
    options[i] = i.toString()
  }
  servesInput.html(Object.entries(options).map(([key,val])=>TEMPLATE`<option value="${key}">${val}</option>`).join(''))  
  servesInput.val(servesInput.attr('value')||'0')
    
  form.on('submit',function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!forms.validate(form)){
      return false;
    }
    var 
      serves = servesInput.val(),
      note = noteInput.val();
      
    if(serves||note){
      ApiServer.mpmealput({date,type,serves,note});
      mealSyncCache.invalidate()
    }
    modal.closeModal(theModal)
    amplify.publish('dishChange')
  })
  return theModal
}

